<template>
  <Form ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100">
    <FormItem label="用户ID"
              prop="userId">
      <Input v-model="formValidate.userId"
             placeholder="用户ID不可更改，不可重复，唯一性，用于系统登录" />
    </FormItem>
    <FormItem label="密码"
              prop="password">
      <Input v-model="formValidate.password"
             placeholder="请输入初始密码" />
    </FormItem>
    <FormItem label="姓名"
              prop="userName">
      <Input v-model="formValidate.userName"
             placeholder="请输入真实姓名" />
    </FormItem>

    <FormItem label="联系电话"
              prop="phone">
      <Input v-model="formValidate.phone"
             placeholder="请输入职员的手机号码" />
    </FormItem>

    <FormItem label="权限"
              prop="lv">
      <RadioGroup v-model="formValidate.lv">
        <Radio label="1">普通用户</Radio>
        <Radio label="9">管理员</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem label="性别"
              prop="gender">
      <RadioGroup v-model="formValidate.gender">
        <Radio label="male">男</Radio>
        <Radio label="female">女</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem>
      <Button type="primary"
              @click="handleSubmit('formValidate')">提交</Button>
      <Button @click="handleReset('formValidate')"
              style="margin-left: 8px">重设</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  data () {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (!/^1[34578]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    return {
      formValidate: {
        userId: '',
        userName: '',
        password: '',
        phone: '',
        gender: '',
        lv: ''
      },
      ruleValidate: {
        userName: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
        userId: [
          {
            required: true,
            message: '工号或用户名不能为空',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            min: 6,
            message: '密码长度必须6位或以上',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        lv: [
          {
            required: true,
            message: '权限级别必须选择',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    formData () {
      let data = {
        userName: this.formValidate.userName,
        userId: this.formValidate.userId,
        password: this.formValidate.password,
        phone: this.formValidate.phone,
        gender: this.formValidate.gender,
        lv: Number(this.formValidate.lv)
      };
      return data;
    }
  },
  methods: {
    handleSubmit (name) {
      console.log(this.formData);
      let _this = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'caiji/?s=user.add',
              data: _this.formData,

              method: 'POST'
            })
            .then(json => {
              console.log(json);
              let jsonData = json.data;
              if (jsonData.ret === 200) {
                _this.$Message.success('添加成功!');
              } else {
                _this.$Message.error(jsonData.msg);
              }
            });
        } else {
          this.$Message.error('Fail!');
        }
      });
    },
    handleReset (name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style lang="css" scoped>
.userAdd {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.userInfoLeft {
  width: 50%;
  height: auto;
  display: flex;
  flex-flow: column nowrap;
}

.userInfoRight {
  width: 50%;
  height: auto;
  display: flex;
  flex-flow: column nowrap;
}

.input {
  width: auto;
  margin-top: 10px;
}
.input.button {
  margin: 10px auto;
  width: 60%;
}
.input.button .submit {
  width: 100%;
}
</style>
